import { PropsWithChildren } from "react";
import { useIntersectionObserver } from "src/hooks/useIntersectionObserver";

interface InfinityScrollProps {
  loadMore: () => void;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  as?: React.ElementType;
}
const OPTIONS = { threshold: 1 };
export const InfinityScroll = ({
  loadMore,
  disabled,
  children,
  style,
  className,
  as: RootElement = "div",
}: PropsWithChildren<InfinityScrollProps>) => {
  const lastItemRef = useIntersectionObserver(loadMore, OPTIONS);

  return (
    <RootElement className={className} style={style}>
      {children}
      {!disabled && <div ref={lastItemRef} />}
    </RootElement>
  );
};
